export enum UserAffiliation {
    FULL_TIME = "Full Time",
    TEMP = "Temp",
    COOP = "Co-op",
    CONTRACTOR = "Contractor",
    FURLOUGHED = "Furloughed",
    PER_DIEM = "Per-Diem",
    PART_TIME = "Part Time",
}

export const UserAffiliations = [
    UserAffiliation.FULL_TIME,
    UserAffiliation.TEMP,
    UserAffiliation.COOP,
    UserAffiliation.CONTRACTOR,
    UserAffiliation.FURLOUGHED,
    UserAffiliation.PER_DIEM,
    UserAffiliation.PART_TIME,
]

export function userAffiliationToColor(userAffiliation: UserAffiliation) {
    switch (userAffiliation) {
        case UserAffiliation.FULL_TIME:
            return "blue"
        case UserAffiliation.TEMP:
            return "lime";
        case UserAffiliation.COOP:
            return "orange";
        case UserAffiliation.CONTRACTOR:
            return "grape";
        case UserAffiliation.FURLOUGHED:
            return "gray"
        case UserAffiliation.PART_TIME:
            return "teal"
        case UserAffiliation.PER_DIEM:
            return "pink"
        default:
            return "black";
    }
}